import { motion } from "framer-motion";
import { TrendingUp, Megaphone, Workflow, Calculator, Users, LineChart, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const ICONS = { sales: TrendingUp, marketing: Megaphone, operations: Workflow, finance: Calculator, hr: Users, executive: LineChart };
const COLORS = { sales: "text-neon-cyan", marketing: "text-neon-violet", operations: "text-neon-magenta", finance: "text-neon-cyan", hr: "text-neon-violet", executive: "text-neon-magenta" };

const Agents = () => {
  const { t } = useLanguage();
  return (
  <section id="agenti" className="py-24 lg:py-32 relative" data-testid="agents-section">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_80%_20%,rgba(112,0,255,0.12),transparent_50%)] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="max-w-3xl mb-16"
      >
        <p className="text-xs font-bold tracking-[0.3em] uppercase text-neon-cyan mb-4">{t.agents.overline}</p>
        <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">
          {t.agents.titleA} <span className="neon-text">{t.agents.titleNeon}</span>
        </h2>
        <p className="mt-6 text-base lg:text-lg text-white/70">
          {t.agents.subtitle}
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {t.agents.list.map((a, i) => {
          const Icon = ICONS[a.id];
          return (
          <motion.article
            key={a.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.12 }}
            data-testid={`agent-card-${a.id}`}
            className="glass-panel spotlight overflow-hidden rounded-2xl p-8 hover:-translate-y-2 hover:shadow-[0_0_30px_rgba(112,0,255,0.25)] transition-all duration-500 group"
          >
            <div className={`w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center mb-6 ${COLORS[a.id]} group-hover:scale-110 transition-transform duration-300`}>
              <Icon size={22} />
            </div>
            <h3 className="font-display text-xl font-bold mb-3">{a.name}</h3>
            <p className="text-sm text-white/70 leading-relaxed mb-5">{a.desc}</p>
            <div className="flex flex-wrap gap-2">
              {a.tags.map((t) => (
                <span key={t} className="text-xs border border-white/10 rounded-full px-3 py-1 text-white/60">
                  {t}
                </span>
              ))}
            </div>
          </motion.article>
          );
        })}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.5 }}
        className="mt-12 text-center"
      >
        <a
          href="/servizi/agenti-ai-per-aziende"
          data-testid="agents-cta-service"
          className="inline-flex items-center gap-2 btn-cyber bg-gradient-to-r from-neon-cyan to-neon-violet px-8 py-4 font-semibold text-void hover:opacity-90 hover:-translate-y-0.5 transition-all duration-300"
        >
          {t.expertise.cta} <ArrowUpRight size={18} />
        </a>
      </motion.div>
    </div>
  </section>
  );
};

export default Agents;
